import React from 'react';
import { ArrowUpRightIcon, PhoneIcon } from 'lucide-react';
import { business } from '../data/site';
type PageHeadingProps = {
  eyebrow: string;
  title: string;
  intro: string;
  showCall?: boolean;
  photo?: {
    src: string;
    position?: string;
    mobilePosition?: string;
  };
  secondaryAction?: {
    href: string;
    label: string;
  };
};
export function PageHeading({
  eyebrow,
  title,
  intro,
  showCall = true,
  photo,
  secondaryAction
}: PageHeadingProps) {
  if (photo) {
    return <section className="page-photo-hero relative isolate flex w-full items-center bg-ink text-white" data-id="element-289" data-mp="1oqigllzd1j5v">
        <img src={photo.src} alt="" aria-hidden="true" className="page-photo-hero__image pointer-events-none absolute inset-0 -z-20 h-full w-full object-cover" style={{
        '--hero-position': photo.position || 'center 45%',
        '--hero-mobile-position': photo.mobilePosition || photo.position || 'center'
      } as React.CSSProperties} loading="eager" fetchPriority="high" data-id="element-290" data-mp="1azm2f066l4ic" />
        <div className="page-photo-hero__shade pointer-events-none absolute inset-0 -z-10" aria-hidden="true" data-id="element-291" data-mp="2emnv0hpukul6" />
        <div className="mx-auto w-full max-w-shell px-5 lg:px-8" data-id="element-292" data-mp="29om97p11eh60">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-light sm:text-[12px]" data-id="element-293" data-mp="2nowywoqm1ppl">
            {eyebrow}
          </p>
          <h1 className="mt-2 max-w-[820px] font-display text-[28px] font-extrabold leading-[1.08] tracking-[-0.02em] sm:text-[36px] lg:text-[42px]" data-id="element-294" data-mp="2jkxmah8gbb1i">
            {title}
          </h1>
          <p className="mt-3 max-w-[640px] text-[15px] leading-[1.5] text-white/90 sm:text-[16px]" data-id="element-295" data-mp="1r07jr66dbb7b">
            {intro}
          </p>
          {(showCall || secondaryAction) && <div className="mt-4 flex max-w-[640px] flex-wrap items-center gap-3" data-id="element-296" data-mp="1zy9fp7b8vdnq">
              {showCall && <a href={business.phoneHref} className="inline-flex min-h-11 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-brand px-3 py-3 font-display text-[14px] font-bold text-white transition-colors hover:bg-brand-light sm:px-5 sm:text-[16px]" data-id="element-297" data-mp="1c7x7dvc37ewm">
                  <PhoneIcon className="h-4 w-4 shrink-0 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-298" data-mp="3caoh4pkw8ds8" />
                  Call {business.phone}
                </a>}
              {secondaryAction && <a href={secondaryAction.href} target="_blank" rel="noreferrer" className="inline-flex min-h-11 min-w-[110px] max-w-[200px] flex-1 items-center justify-center gap-1.5 rounded-md border border-white/40 px-2 py-2 text-center text-[13px] font-semibold leading-snug text-white transition-colors hover:border-white/80 sm:min-w-0 sm:max-w-none sm:flex-none sm:px-5 sm:text-[15px]" data-id="element-299" data-mp="3m07zzv8lw7n3">
                  {secondaryAction.label}
                  <ArrowUpRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-300" data-mp="338owlnao6rkj" />
                </a>}
            </div>}
        </div>
      </section>;
  }
  return <section className="w-full bg-ink py-14 text-white lg:py-20" data-id="element-301" data-mp="imx21z8a63db">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-302" data-mp="231jut1jmnn4i">
        <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-light" data-id="element-303" data-mp="1y40gk1mxjack">
          {eyebrow}
        </p>
        <h1 className="mt-4 max-w-[820px] font-display text-[34px] font-extrabold leading-[1.06] tracking-[-0.02em] sm:text-[44px] lg:text-[52px]" data-id="element-304" data-mp="1tca3vp0isahz">
          {title}
        </h1>
        <p className="mt-5 max-w-[640px] text-[17px] leading-relaxed text-chalk/75" data-id="element-305" data-mp="1jem24f4hy2qb">
          {intro}
        </p>
        {showCall && <a href={business.phoneHref} className="mt-8 inline-flex items-center gap-3 whitespace-nowrap rounded-md bg-brand px-6 py-3.5 font-display text-[17px] font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-306" data-mp="1fbpgsgnknsio">
            <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-307" data-mp="34r5orsprf86z" />
            Call {business.phone}
          </a>}
      </div>
    </section>;
}